import  api, { globalErrorHandler } from "../Api"

export const GET_NEWSLETTERS = "GET_NEWSLETTERS";
export const GET_CURRENT_NEWSLETTERS = "GET_CURRENT_NEWSLETTERS";
export const DELETE_NEWSLETTER = "DELETE_NEWSLETTER";
export const ADD_NEWSLETTER = "ADD_NEWSLETTER";
export const UPDATE_NEWSLETTER = "UPDATE_NEWSLETTER";
export const GET_NEWSLETTER_BY_ID = "GET_NEWSLETTER_BY_ID";
export const NWL_LOADING = "NWL_LOADING";
export const NWL_ERROR = "NWL_ERROR";

const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetNewsletters = (applicationId) => {
  
  return async dispatch => {
    dispatch({
      type: NWL_LOADING
    });
    await api.get(`/Newsletter`,config).then(res => 
      dispatch({
        type: GET_NEWSLETTERS,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};

export const GetCurrentNewsletters = () => {
  
  return async dispatch => {
    dispatch({
      type: NWL_LOADING
    });
    await api.get(`/Newsletter/GetCurrentNewsletters`,config).then(res => {
      dispatch({
        type: GET_CURRENT_NEWSLETTERS,
        data: res.data
        });
    }).catch(globalErrorHandler); 
  };
};

export const GetNewsletterById = (id) => {
  const config = {
      headers: {
          'content-type': 'application/json',
      }
    }  
  return async dispatch => {
    dispatch({
      type: NWL_LOADING
    });
    await api.get(`/Newsletter/${id}`,config).then(res => {
      dispatch({
        type: GET_NEWSLETTER_BY_ID,
        data: res.data
      });

      //console.log("categoriesaction", res.data)
    })
    .catch((error) => {
      globalErrorHandler(error);
      dispatch({
        type: NWL_ERROR 
      })
    });
  };
};

export const AddNewsletter = (payload) => {
  //console.log("addver", payload, files)
  return async dispatch => {
      dispatch({
          type: NWL_LOADING
      });

      api.post(`/Newsletter`, 
      payload, config).then(res => {
          dispatch({
              type: ADD_NEWSLETTER,
              payload: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: NWL_ERROR 
        })
      });
  };
};

export const UpdateNewsletter = (payload) => {
  return async dispatch => {
      dispatch({
          type: NWL_LOADING
      });

      api.put(`/Newsletter`, 
      payload, config).then(res => {
          dispatch({
              type: UPDATE_NEWSLETTER,
              payload: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: NWL_ERROR 
        })
      });
  };
};

export const DeleteNewsletter = (id) => dispatch => {
  dispatch({
      type: NWL_LOADING
  });
  
  api.delete(`/Newsletter/Delete/${id}`).then(res => {
      dispatch({
          type: DELETE_NEWSLETTER,
          payload: res.data
      });
  })
  .catch((error) => {
    globalErrorHandler(error);
    dispatch({
      type: NWL_ERROR
    })
  });
};
